import API_ENDPOINTS from '../config/apiConfig';
import { api } from './api';

// Fetch revenue export data with pagination
export const getRevenueExport = async (filters = {}) => {
  try {
    const { locationId, startDate, endDate, page = 1, pageSize = 25, groupByAccount = false, targetCurrency } = filters;

    // Validate required parameters
    if (!locationId) {
      throw new Error('locationId is required');
    }

    if (!startDate || !endDate) {
      throw new Error('startDate and endDate are required');
    }

    // Create URL with query parameters
    const queryParams = [
      `locationId=${locationId}`,
      `startDate=${startDate}`,
      `endDate=${endDate}`,
      `page=${page}`,
      `pageSize=${pageSize}`
    ];

    if (groupByAccount) {
      queryParams.push('groupByAccount=true');
    }
    if (targetCurrency) {
      queryParams.push(`targetCurrency=${encodeURIComponent(targetCurrency)}`);
    }

    const url = `${API_ENDPOINTS.REVENUE_EXPORT}?${queryParams.join('&')}`;
    const response = await api.get(url);

    return response.data;
  } catch (error) {
    console.error('Error in getRevenueExport:', error);
    throw error;
  }
};

// Fetch all revenue export data (for export functionality)
export const getAllRevenueExport = async (filters = {}) => {
  try {
    const { locationId, startDate, endDate, groupByAccount = false, targetCurrency } = filters;

    // Validate required parameters
    if (!locationId) {
      throw new Error('locationId is required');
    }

    if (!startDate || !endDate) {
      throw new Error('startDate and endDate are required');
    }

    // Create URL with query parameters
    const queryParams = [
      `locationId=${locationId}`,
      `startDate=${startDate}`,
      `endDate=${endDate}`,
      `exportAll=true`
    ];

    if (groupByAccount) {
      queryParams.push('groupByAccount=true');
    }
    if (targetCurrency) {
      queryParams.push(`targetCurrency=${encodeURIComponent(targetCurrency)}`);
    }

    const url = `${API_ENDPOINTS.REVENUE_EXPORT}?${queryParams.join('&')}`;
    const response = await api.get(url);

    return response.data;
  } catch (error) {
    console.error('Error in getAllRevenueExport:', error);
    throw error;
  }
};
